<template>
  <b-container class="p-0">
    <TabView class="tabview-custom transaction-tabs position-relative" v-model:activeIndex="activeTabIndex"
      @tabChange="onTabChange" ref="tabview4">
      <TabPanel>
        <template #header>
          <div class="d-flex align-items-center settabheight">
            <span style="padding: 0px 7px">Request</span>
          </div>
        </template>
        <div>
          <DisposalManagementScreen />
        </div>
      </TabPanel>
      <TabPanel>
        <template #header>
          <div class="d-flex align-items-center settabheight">
            <span style="padding: 0px 7px">Process</span>
          </div>
        </template>
        <div>
          <DisposalProcess :activeIndex="activeTabIndex" />
        </div>
      </TabPanel>
      <TabPanel>
        <template #header>
          <div class="d-flex align-items-center settabheight">
            <span style="padding: 0px 7px">Complete</span>
          </div>
        </template>
        <div>
          <CompleteDisposal :activeIndex="activeTabIndex"/>
        </div>
      </TabPanel>
    </TabView>
  </b-container>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted, reactive,watch } from "vue";

import DisposalProcess from './DisposalProcess.vue'
import DisposalManagementScreen from './DisposalManagementScreen.vue';
import CompleteDisposal from './CompleteDisposal.vue';
export default defineComponent({
    components:{
        DisposalProcess,
        DisposalManagementScreen,
        CompleteDisposal
    },
    setup() {
        const activeTabIndex=ref(0);
        const onTabChange = (event: any) => {
            activeTabIndex.value = event.index;
            };
              watch( () => activeTabIndex.value,
            (newVal: any) => {
                
                activeTabIndex.value = newVal;
            }
        );
        return{
          activeTabIndex,
          onTabChange
        }
    },
})
</script>

